import { API_CONSTANTS } from "../../constants/apiConstants";
import baseApi from "./baseApiService";

export const CommunicationLogsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCommunicationLogs: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_COMMUNICATION_LOGS}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    getCommunicationLogsHistory: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_COMMUNICATION_LOGS_HISTORY}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    resendCommunication: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.RESEND_COMMUNICATIOM}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    getAllBpCommunicationLogs: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_BP_COMMUNICATION_LOGS}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    getBpCommunicationLogsHistory: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_BP_COMMUNICATION_LOGS_HISTORY}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    retryUploadToBP: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.RETRY_UPLOAD_TO_BP}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    getDocumentNames: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_DOCUMENT_NAMES}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});
export const {
  useLazyGetAllCommunicationLogsQuery,
  useGetCommunicationLogsHistoryQuery,
  useLazyResendCommunicationQuery,
  useGetBpCommunicationLogsHistoryQuery,
  useLazyGetAllBpCommunicationLogsQuery,
  useLazyRetryUploadToBPQuery,
  useGetDocumentNamesQuery,
  useLazyGetDocumentNamesQuery,
} = CommunicationLogsApi;
